<template lang="html">
  <FrsModuleRoot
    :module="module"
    :module-path="['fieldRecordSystem', 'automaticZoneMaps']"
    :translation-namespaces="['automaticZoneMaps', 'Common.SR_Common']"
    :setup="loadPrerequisiteData"
  >
    <FrsRouterBackLink target="fieldDashboard">
      <template #text>
        <IxRes>automaticZoneMaps.buttons.backToDashboard</IxRes>
      </template>
    </FrsRouterBackLink>

    <router-view />
  </FrsModuleRoot>
</template>

<script>
import {mapActions} from 'vuex'

import FrsModuleRoot from '@frs/components/base/FrsModuleRoot'
import FrsRouterBackLink from '@frs/components/base/FrsRouterBackLink'

export default {
  components: {
    FrsRouterBackLink,
    FrsModuleRoot
  },
  computed: {
    module () {
      return () => import('@store/modules/field-record-system/automatic-zone-maps')
    }
  },
  methods: {
    ...mapActions('fieldRecordSystem/automaticZoneMaps', [
      'loadPrerequisiteData'
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
